const objectField = (args) => {
    return Object.assign({ type: 'object' }, args);
};
const arrayField = (args) => {
    return Object.assign({ type: 'array' }, args);
};
const stringField = (args) => {
    return Object.assign({ type: 'string' }, args);
};
const numberField = (args) => {
    return Object.assign({ type: 'number' }, args);
};
const booleanField = (args) => {
    return Object.assign({ type: 'boolean' }, args);
};
const anyField = (args) => {
    return Object.assign({ type: 'any' }, args);
};
const mapField = (args) => {
    return Object.assign({ type: 'map' }, args);
};
const fileField = (args) => {
    return Object.assign({ type: 'file' }, args);
};
export const fields = {
    object: objectField,
    array: arrayField,
    string: stringField,
    number: numberField,
    boolean: booleanField,
    any: anyField,
    map: mapField,
    file: fileField,
};
//# sourceMappingURL=fieldHelpers.js.map